"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PropertyType;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactRedux = require("react-redux");
var _actions = require("../store/actions");
var _usersession = require("usersession");
var _Asset = _interopRequireDefault(require("../assets/Asset 4.jpg"));
var _Asset2 = _interopRequireDefault(require("../assets/Asset 5.jpg"));
var _Asset3 = _interopRequireDefault(require("../assets/Asset 6.jpg"));
var _Asset4 = _interopRequireDefault(require("../assets/Asset 7.jpg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { useRatesContext } from "../context/ratesContext";

const scrollToRef = ref => window.scrollTo(0, ref.current.offsetTop, {
  behavior: "smooth"
});
// General scroll to element function

function PropertyType() {
  // const { ShowButtons, propertyTypeUpdate, state } = useRatesContext();
  const userSession = new _usersession.UserSession();
  const [propertyType, setPropertyType] = (0, _react.useState)("");
  const [unitsInput, setUnitsInput] = (0, _react.useState)("");
  const dispatch = (0, _reactRedux.useDispatch)();
  const propertyTypeRedux = (0, _reactRedux.useSelector)(state => state.nameReducer.propertyType);
  // const propertyTypeRedux = state.propertyType;

  const myRefProp = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    //This function scroll the slider into view
    !localStorage.getItem("doNotScroll") && scrollToRef(myRefProp);
  }, []);
  (0, _react.useEffect)(() => {
    dispatch((0, _actions.ShowButtons)(false));
    // ShowButtons(false);

    setPropertyType(propertyTypeRedux);
    userSession.setPropertyType(propertyTypeRedux);
    switch (propertyType) {
      case "DUPLEX":
      case "TRIPLEX":
      case "FOURPLEX":
      case "OVER FOUR":
        setUnitsInput("UNITS");
        break;
      // no default
    }
    if (propertyType.length > 0) dispatch((0, _actions.ShowButtons)(true));
    // ShowButtons(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyType, unitsInput]);
  function handleUnitProp(value) {
    setUnitsInput(value);
  }
  function handleProperty(value) {
    setPropertyType(value);
    userSession.setPropertyType(value);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "mb-0"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 12,
    className: "text-center mb-4"
  }, /*#__PURE__*/_react.default.createElement("h2", null, "What is your property type?")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    ref: myRefProp,
    lg: 2,
    className: "mb-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    type: "radio",
    inline: true,
    id: "sfrProperty",
    value: "SFR",
    label: "Single Family",
    checked: propertyType === "SFR",
    onChange: e => {
      handleProperty(e.target.value);
      setUnitsInput("");
      dispatch((0, _actions.propertyTypeUpdate)(e.target.value));
      // propertyTypeUpdate(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Image, {
    src: _Asset.default,
    alt: "Single family Home",
    className: "radImg2 rounded-circle radImg customShadow \n                                ".concat(propertyType === "SFR" ? "d-none" : "")
  })), /*#__PURE__*/_react.default.createElement("h4", null, "Single Family")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 2,
    className: "mb-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    type: "radio",
    inline: true,
    id: "condoProperty",
    value: "CONDO",
    label: "Condo",
    checked: propertyType === "CONDO",
    onChange: e => {
      handleProperty(e.target.value);
      setUnitsInput("");
      dispatch((0, _actions.propertyTypeUpdate)(e.target.value));
      // propertyTypeUpdate(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _Asset2.default,
    alt: "Condo",
    className: "radImg2 rounded-circle radImg customShadow ".concat(propertyType === "CONDO" ? "d-none" : "")
  })), /*#__PURE__*/_react.default.createElement("h4", null, "Condo")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 2,
    className: "mb-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    type: "radio",
    inline: true,
    id: "manuProperty",
    value: "MANUFACTURED",
    label: "Manufactured Home",
    checked: propertyType === "MANUFACTURED",
    onChange: e => {
      handleProperty(e.target.value);
      setUnitsInput("");
      dispatch((0, _actions.propertyTypeUpdate)(e.target.value));
      // propertyTypeUpdate(e.target.value);
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _Asset3.default,
    alt: "Manufactured Home",
    className: "radImg2 rounded-circle radImg customShadow ".concat(propertyType === "MANUFACTURED" ? "d-none" : "")
  })), /*#__PURE__*/_react.default.createElement("h4", null, "Manufactured Home")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 2,
    className: ""
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "overlay"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Check, {
    type: "radio",
    inline: true,
    id: "unitsProperties",
    value: "UNITS",
    label: "Units Home",
    checked: unitsInput === "UNITS",
    onChange: e => {
      handleUnitProp(e.target.value);
      handleProperty("DUPLEX");
      dispatch((0, _actions.propertyTypeUpdate)("DUPLEX"));
      // propertyTypeUpdate("DUPLEX");
    }
  }), /*#__PURE__*/_react.default.createElement("img", {
    src: _Asset4.default,
    alt: "Units Home",
    className: "radImg2 rounded-circle radImg customShadow ".concat(unitsInput === "UNITS" ? "d-none" : "")
  })), /*#__PURE__*/_react.default.createElement("h4", null, "Units Home"))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Fade, {
    in: unitsInput === "UNITS"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "".concat(unitsInput !== "UNITS" ? "d-none" : "d-flex justify-content-center text-left pt-4")
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: "mb-2",
    as: _reactBootstrap.Col,
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    className: "sr-only"
  }, "Units"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Select, {
    value: propertyType,
    onChange: e => {
      handleProperty(e.target.value);
      dispatch((0, _actions.propertyTypeUpdate)(e.target.value));
      // propertyTypeUpdate(e.target.value);
    }
  }, /*#__PURE__*/_react.default.createElement("option", {
    value: "DUPLEX"
  }, "Duplex (2 UNITS)"), /*#__PURE__*/_react.default.createElement("option", {
    value: "TRIPLEX"
  }, "Triplex (3 UNITS)"), /*#__PURE__*/_react.default.createElement("option", {
    value: "FOURPLEX"
  }, "Quadplex (4 UNITS)")))))));
}